import React, { useState, useEffect } from "react";
import arrowtopoutline from "../../images/arrow-top-outline.svg";
import saveoutline from "../../images/save-outline.svg";
import heartoutline from "../../images/heart-outline.svg";
import save from "../../images/save.svg";
import profile_img from "../../images/profile_img.svg";
import backarrow from "../../images/back-arrow.svg";
import heart from "../../images/heart.svg";
import vshort from "../../images/v-short.svg";
import broker_sanda from "../../images/broker_sanda.png";
import star_broker from "../../images/star_broker.svg";
import socialeicon from "../../images/social-e-icon.svg";
import socialinicon from "../../images/social-in-icon.svg";
import check_icon_new from "../../images/check_icon_new.svg";
import socialxicon from "../../images/social-x-icon.svg";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from "../../constants/apiConstants";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper/modules";
import { ToastContainer, toast, Slide } from "react-toastify";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import Lottie from "react-lottie";
import likeAnimationData from "../../assets/like_animation.json";
import bookmarkAnimationData from "../../assets/bookmark.json";
import "../../ashAed/uae-symbol.css";
import unlikeheart from "../../images/unlike-heart.svg";
import unsaved from "../../images/un-saved.svg";
import { Link } from "react-router-dom";
import profileImg from "../../images/profile_img.svg";
import searchIcon from "../../images/search-icon.svg";
import sanda1 from "../../images/sanda-1.png";
import sanda2 from "../../images/sanda-2.png";
import sanda3 from "../../images/sanda-3.png";
import sanda4 from "../../images/sanda-4.png";
import sanda5 from "../../images/sanda-5.png";

function Details() {
  const token = localStorage.getItem("ACCESS_TOKEN");
  const [propertiesList, setPropertiesList] = useState([]);
  const [properties, setProperties] = useState([]);
  const [latestProperties, setLatestProperties] = useState([]);
  const [likes, setLikes] = useState([]);
  const [saved, setSaved] = useState([]);
  const [visibility, setVisibility] = useState(
    properties.reduce((acc, item) => {
      acc[item] = false; // Initially, all items are hidden
      return acc;
    }, {})
  );

  const [visibilitySaved, setVisibilitySaved] = useState(
    properties.reduce((acc, item) => {
      acc[item] = false; // Initially, all items are hidden
      return acc;
    }, {})
  );

  const [skip, setSkip] = useState(0);

  const payload = {
    type: 0,
  };

  const fetchProperties = () => {
    axios
      .get(
        API_BASE_URL + `get/home/properties?_skip=${skip}&_limit=36`,
        {
          headers: {
            Authorization: `Bearer ${Bearer_Token}`,
          },
        }
      )
      .then((response) => {
        setProperties(response.data.data.pData);
        setPropertiesList(response.data.data.pData);
        setSkip(response.data.data.length);
      })
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const fetchLatestProperties = () => {
    axios.get(
      API_BASE_URL + 'get/latest/property',
      {
          headers: {
            Authorization: `Bearer ${Bearer_Token}`,
          },
      }
    ).then((response) => {
      setLatestProperties(response.data.data);
    }).catch((error) => {
      toast.error(error, {
        position: "top-right",
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    });
  }

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: likeAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: bookmarkAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const toggleVisibility = (item, status) => {
    setVisibility((prevState) => ({
      ...prevState,
      [item]: !prevState[item], // Toggle the visibility of the clicked item
    }));

    if (status === false) {
      likes.push(item);
      setLikes([...likes]);
    } else if (status === true) {
      let index = likes.findIndex((x) => x === item);
      likes.splice(index, 1);
      setLikes([...likes]);
    }

    setTimeout(() => {
      setVisibility("");
    }, 1000);

    const payload = {
      property_id: item,
      type: 1,
    };
    axios
      .post(API_BASE_URL + "add/like", payload, {
        headers: {
          Authorization: `Bearer ${Bearer_Token}`,
        },
      })
      .then((response) => {})
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const toggleLike = (item, status) => {
    if (status === 1) {
      setVisibility((prevState) => ({
        ...prevState,
        [item]: !prevState[item], // Toggle the visibility of the clicked item
      }));
    }

    let index = likes.findIndex((x) => x === item);
    if (index >= 0) likes.splice(index, 1);
    else likes.push(item);
    setLikes([...likes]);

    setTimeout(() => {
      setVisibility("");
    }, 1000);

    const payload = {
      property_id: item,
      type: 2,
    };
    axios
      .post(API_BASE_URL + "add/like", payload, {
        headers: {
          Authorization: `Bearer ${Bearer_Token}`,
        },
      })
      .then((response) => {})
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const toggleSaved = (item, status) => {
    if (status === 1) {
      setVisibilitySaved((prevState) => ({
        ...prevState,
        [item]: !prevState[item], // Toggle the visibility of the clicked item
      }));
    }

    setTimeout(() => {
      setVisibilitySaved("");
    }, 1000);

    const payload = {
      property_id: item,
    };
    axios
      .post(API_BASE_URL + "add/bookmark", payload, {
        headers: {
          Authorization: `Bearer ${Bearer_Token}`,
        },
      })
      .then((response) => {})
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });

    let index = saved.findIndex((x) => x === item);
    if (index >= 0) saved.splice(index, 1);
    else saved.push(item);
    setSaved([...saved]);
  };

  const firstLogin = () => {
    toast.error("Please login to this event.", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
      transition: Slide,
    });
  };

  const [searchVal, setSearchVal] = useState("");
  const handleSearchClick = () => {
    const searchTerm = searchVal;

    const filteredItems = propertiesList.filter((item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setProperties(filteredItems);
  };

  useEffect(() => {
    fetchProperties();
    fetchLatestProperties();
  }, []);

  return (
    <>
      <ToastContainer />
      <section class="grid_box">
        <div class="container">
          <div class="text_he_box">
            <div class="row justify-content-between align-items-center">
              <div class="col-md-6">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                  <h4>
                    <img src={backarrow} alt="" /> Broker Details
                    <span>- Sanda Ali </span>
                  </h4>
                  <h4>Verified Broker</h4>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-wrap justify-content-between align-items-center px-0 px-lg-5">
                  <ul>
                    <li>
                      <a href="#">
                        Share <img src={arrowtopoutline} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        Save <img src={saveoutline} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        Like <img src={heartoutline} alt="" />
                      </a>
                    </li>
                  </ul>
                  <a href="#" class="button_gredient_edit">
                    EDIT
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="broker_detail">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="broker_main_sec">
                <div class="row g-0">
                  <div class="col-md-7">
                    <div class="brok-s-img">
                      <Swiper
                        direction={"horizontal"}
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={true}
                        pagination={{
                          clickable: true,
                        }}
                        modules={[Mousewheel, Pagination]}
                        className="mySwiper"
                        speed={1000}
                        mousewheel={true}
                      >
                        <SwiperSlide>
                          <img src={broker_sanda} alt="" />
                        </SwiperSlide>
                        <SwiperSlide>
                          <img src={sanda1} alt="" />
                        </SwiperSlide>
                        <SwiperSlide>
                          <img src={sanda2} alt="" />
                        </SwiperSlide>
                        <SwiperSlide>
                          <img src={sanda3} alt="" />
                        </SwiperSlide>
                        <SwiperSlide>
                          <img src={sanda4} alt="" />
                        </SwiperSlide>
                        <SwiperSlide>
                          <img src={sanda5} alt="" />
                        </SwiperSlide>

                      </Swiper>

                      
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="brok_s_content">
                      <div class="shave_icon_top">
                      <img src={save} alt=""/>
                        </div>
                      <div class="profile_box4 text-center">
                        <div class="position-relative d-inline">

                          <img
                            class="agent-profile-picture"
                            src={profile_img}
                            alt=""
                          />
                          <img class="v-agent-profile" src={vshort} alt="" />
                        </div>
                        <h5>sanda</h5>
                        <h4>Sanda Ali</h4>
                        <p>on Verified Properties since 1 May 2025</p>
                        <span class="ver-bro">VERIFIED BROKER</span>

                        <ul>
                          <li>
                            <img src={star_broker} alt="" />
                          </li>
                          <li>
                            <img src={star_broker} alt="" />
                          </li>
                          <li>
                            <img src={star_broker} alt="" />
                          </li>
                          <li>
                            <img src={star_broker} alt="" />
                          </li>
                          <li>
                            <img src={star_broker} alt="" />
                          </li>
                        </ul>

                        <a href="#" class="button_gredient_follow">
                          FOLLOW
                        </a>

                        <div class="bork-short-cont">
                          <div class="d-flex justify-content-between align-items-center">
                            <span>Age</span>
                            <p>25</p>
                          </div>
                          <div class="d-flex justify-content-between align-items-center">
                            <span>City</span>
                            <p>New York City</p>
                          </div>
                          <div class="d-flex justify-content-between align-items-center">
                            <span>State</span>
                            <p>New York</p>
                          </div>
                          <div class="d-flex justify-content-between align-items-center">
                            <span>Country</span>
                            <p>USA</p>
                          </div>
                          <div class="d-flex justify-content-between align-items-center">
                            <span>Post Code</span>
                            <p>2003</p>
                          </div>
                        </div>

                        <div class="box_bottom_social">
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="link_socil_e">
                              <ul>
                                <li>
                                  <img src={socialeicon} alt="" />
                                </li>
                                <li>
                                  <img src={socialxicon} alt="" />
                                </li>
                                <li>
                                  <img src={socialinicon} alt="" />
                                </li>
                              </ul>
                            </div>
                            <div class="heart_icon_2">
                              <img src={heart} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                <div class="d-flex flex-wrap justify-content-between align-items-center text_he_box2 broker_det_pad">
                  <h4>Latest Listings</h4>
                  <h4 class="text-end">View All Listings</h4>
                </div>

              <div class="d-flex photo_gal flex-wrap justify-content-between align-items-center mt-5">
                    <Swiper
                        direction={"horizontal"}
                        spaceBetween={10}
                        slidesPerView={7}
                        loop={true}
                        className="mySwiper"
                        speed={1000}
                        mousewheel={true}
                    >
                    {latestProperties.map((property) => (
                      property.photos.slice(0, 1).map((item) => (
                          <SwiperSlide>
                              <img className="property-media-image" src={ASSETS_URL+"properties/media/small/"+item} alt="" width={95} height={95} />
                          </SwiperSlide>
                      ))
                    ))}
                    </Swiper>
              </div>

            </div>
            <div class="col-md-6">
              <div class="brok-det right_side_box">
                <div class="brok-head">
                  <div class="d-flex justify-content-between">
                    <h4>SANDA ALI</h4>
                    <span>Broker Details</span>
                  </div>
                </div>

                <div class="brok-text">
                  <p>
                    Hello! My name is Sanda Ali and I am a Licensed Broker with
                    City Centre Real Estate. We specialize in renting out our
                    unique, value for money apartments in Dubai. We understand
                    the importance of personalized service. Our team consists of
                    a broad range of people that have lived in Dubai for many
                    years and we speak multiple languages. We are passionate
                    about hosting guests at our properties in Dubai.
                  </p>
                  <p>
                    Real Estate Buying & Selling Brokerage, Real Estate
                    Management Supervision Services, Leasing Property Brokerage
                    Agents.
                  </p>

                  <div class="points_bro_det">
                    <div class="row">
                      <div className="col-md-9">
                        <div class="d-flex justify-content-start align-items-center pb-3">
                          <span>
                            <img src={check_icon_new} alt="" /> Agency
                          </span>
                          <p>City Centre Real Estate</p>
                        </div>
                        <div class="d-flex justify-content-start align-items-center pb-3">
                          <span>
                            <img src={check_icon_new} alt="" /> Broker Number
                          </span>
                          <p>1109</p>
                        </div>
                        <div class="d-flex justify-content-start align-items-center pb-3">
                          <span>
                            <img src={check_icon_new} alt="" /> Tax Number
                          </span>
                          <p>TN 45C0 584R NP34</p>
                        </div>
                        <div class="d-flex justify-content-start align-items-center">
                          <span>
                            <img src={check_icon_new} alt="" /> Service Area
                          </span>
                          <p>New York, Dubai, Los Angeles, London, Paris</p>
                        </div>
                      </div>
                      <div className="col-md-3 d-flex justify-content-end align-items-end">
                        <a href="#" class="button_gredient_chat">
                          CHAT NOW
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bottom_mew_n">
                <div className="head-new_b">
                  <h4>Property Status</h4>
                  <div className="boxes_four">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="box_sh_fou">
                          <span>Total Listings</span>
                          <h2>1500</h2>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="box_sh_fou">
                          <span>Sold Properties</span>
                          <h2>1200</h2>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="box_sh_fou">
                          <span>Rent Properties</span>
                          <h2>1000</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mb-3">
              <span class="border_radius_gredient"></span>
            </div>
          </div>

          <section class="grid_box">
            <div class="container p-0">
              <div className="row align-items-center text_he_box">
                <div className="col-md-4">
                  <h4>Sanda’s Listings</h4>
                </div>
                <div className="col-md-4">
                  <div class="searchbox d-flex">
                    <input
                      class="form-control"
                      placeholder="Search All"
                      type="text"
                      onChange={(e) => setSearchVal(e.target.value)}
                    />
                    <button type="button" onClick={handleSearchClick}>
                      <img alt="search-icon" src={searchIcon} />
                    </button>
                  </div>
                </div>
                <div className="col-md-4">
                  
                  <h4 className="property-title text-end">
                    Verified Properties
                  </h4>
                </div>
              </div>

              {/* <div class="text_he_box d-flex justify-content-between align-items-center">
                    <h4>All Properties</h4>
                    <div class="searchbox d-flex"><input class="form-control" placeholder="Search All" type="text"/><button type="button"><img alt="search-icon" src="/static/media/search-icon.f9aaf195dd5c680284dafd8006f643de.svg"/></button></div>
                    <h4 className="property-title">Verified Properties</h4>
                </div> */}
              <div class="row g-5 grid_box_2">
                {properties.map((property) => (
                  <div class="col-md-2 property-des">
                    <div class="feature_image">
                      <Swiper
                        direction={"horizontal"}
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={true}
                        // onSlideChange={() => console.log('slide change')}
                        // onSwiper={(swiper) => console.log(swiper)}
                        pagination={{
                          clickable: true,
                        }}
                        modules={[Mousewheel, Pagination]}
                        className="mySwiper"
                        speed={1000}
                        mousewheel={true}
                      >
                        {property.photos.slice(0, 1).map((image) => (
                          <SwiperSlide>
                            {!token || token === "undefined" ? (
                              <img
                                className="property-image"
                                src={
                                  ASSETS_URL +
                                  "properties/media/medium/" +
                                  image
                                }
                                alt=""
                                width="100%"
                              />
                            ) : (
                              <img
                                className="property-image"
                                src={
                                  ASSETS_URL +
                                  "properties/media/medium/" +
                                  image
                                }
                                alt=""
                                width="100%"
                                onDoubleClick={() =>
                                  toggleVisibility(
                                    property.id,
                                    property.is_like
                                  )
                                }
                              />
                            )}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      {visibility[property.id] && (
                        <span className="like-animation">
                          <Lottie
                            options={defaultOptions1}
                            height={100}
                            width={100}
                          />
                        </span>
                      )}

                      {visibilitySaved[property.id] && (
                        <span className="like-animation">
                          <Lottie
                            options={defaultOptions2}
                            height={100}
                            width={100}
                          />
                        </span>
                      )}

                      {token && token !== "undefined" ? (
                        property.is_bookmark === true ? (
                          saved.findIndex((x) => x === property.id) >= 0 ? (
                            <span class="save">
                              <img
                                src={unsaved}
                                width="20px"
                                alt="save"
                                onClick={() => toggleSaved(property.id, 1)}
                              />
                            </span>
                          ) : (
                            <span class="save">
                              <img
                                src={save}
                                width="20px"
                                alt="save"
                                onClick={() => toggleSaved(property.id, 2)}
                              />
                            </span>
                          )
                        ) : saved.findIndex((x) => x === property.id) >= 0 ? (
                          <span class="save">
                            <img
                              src={save}
                              width="20px"
                              alt="save"
                              onClick={() => toggleSaved(property.id, 2)}
                            />
                          </span>
                        ) : (
                          <span class="save">
                            <img
                              src={unsaved}
                              width="20px"
                              alt="save"
                              onClick={() => toggleSaved(property.id, 1)}
                            />
                          </span>
                        )
                      ) : (
                        <span class="save">
                          <img
                            src={unsaved}
                            width="20px"
                            alt="save"
                            onClick={firstLogin}
                          />
                        </span>
                      )}

                      <span class="profile_img">
                        <img src={profileImg} width="30px" alt="profile_img" />
                      </span>

                      {token && token !== "undefined" ? (
                        property.is_like === true ? (
                          likes.findIndex((x) => x === property.id) >= 0 ? (
                            <span class="heart">
                              <img
                                src={unlikeheart}
                                width="25px"
                                alt="heart"
                                onClick={() => toggleLike(property.id, 1)}
                              />
                            </span>
                          ) : (
                            <span class="heart">
                              <img
                                src={heart}
                                width="25px"
                                alt="heart"
                                onClick={() => toggleLike(property.id, 2)}
                              />
                            </span>
                          )
                        ) : likes.findIndex((x) => x === property.id) >= 0 ? (
                          <span class="heart">
                            <img
                              src={heart}
                              width="25px"
                              alt="heart"
                              onClick={() => toggleLike(property.id, 2)}
                            />
                          </span>
                        ) : (
                          <span class="heart">
                            <img
                              src={unlikeheart}
                              width="25px"
                              alt="heart"
                              onClick={() => toggleLike(property.id, 1)}
                            />
                          </span>
                        )
                      ) : (
                        <span class="heart">
                          <img
                            src={unlikeheart}
                            width="25px"
                            alt="heart"
                            onClick={firstLogin}
                          />
                        </span>
                      )}
                    </div>
                    <Link to={`/property/${property.id}`}>
                      <div class="text_feature">
                        <h4>{property.title}</h4>
                        <span class="d-flex align-items-center">
                          {/* <img src={location} alt="location"/>  */}
                          <p>{property.location_title}</p>
                        </span>

                        <span class="d-flex justify-content-between align-items-center">
                          <p>{property.square_feet} sq ft</p>
                          <p>{property.number_of_bathroom} Bathrooms</p>
                          <p>{property.number_of_bedroom} Bedrooms</p>
                        </span>
                      </div>
                      <div class="price_box d-flex align-items-center  justify-content-between ">
                        <h3>
                          {property.currency === "AED" && (
                            // <img className="dirham-icon" src={dIcon} alt=""/>
                            <span class="dirham-symbol">&#xea;</span>
                          )}
                          {(() => {
                            switch (property.currency) {
                              case "AED":
                                return new Intl.NumberFormat("en-AE", {
                                  currency: "AED",
                                  maximumFractionDigits: 0,
                                }).format(
                                  property.amount.replace(/[AED$£€₹, ]/g, "")
                                );
                              case "USD":
                                return new Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                  maximumFractionDigits: 0,
                                }).format(
                                  property.amount.replace(/[AED$£€₹, ]/g, "")
                                );
                              case "GBP":
                                return new Intl.NumberFormat("en-GB", {
                                  style: "currency",
                                  currency: "GBP",
                                  maximumFractionDigits: 0,
                                }).format(
                                  property.amount.replace(/[AED$£€₹, ]/g, "")
                                );
                              case "EUR":
                                return new Intl.NumberFormat("en-BE", {
                                  style: "currency",
                                  currency: "EUR",
                                  maximumFractionDigits: 0,
                                }).format(
                                  property.amount.replace(/[AED$£€₹, ]/g, "")
                                );
                              case "INR":
                                return new Intl.NumberFormat("en-IN", {
                                  style: "currency",
                                  currency: "INR",
                                  maximumFractionDigits: 0,
                                }).format(
                                  property.amount.replace(/[AED$£€₹, ]/g, "")
                                );
                              default:
                                return "";
                            }
                          })()}
                        </h3>
                        <span>{property.listing_type.toUpperCase()}</span>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
}

export default Details;
